// Mint-HR-Review · logic thuần (dữ liệu mẫu theo script board; chưa ghi DB). Không tiền / lương: xếp loại A–D chỉ là nhãn.

export type CycleStatus = 'open' | 'closed' | 'draft';
/** [nhãn bước, hạn, đã xong, tổng] */
export type CycleStep = readonly [string, string, number, number];
export interface Cycle { id: string; name: string; type: string; range: string; status: CycleStatus; steps: readonly CycleStep[] }

export const CYCLES: readonly Cycle[] = [
  { id: 'Y26', name: 'Đánh giá cuối năm 2026', type: 'Định kỳ năm', range: '01/Dec – 20/Dec/2026', status: 'open', steps: [['Tự đánh giá', '01–07/Dec', 21, 36], ['Quản lý chấm', '08–14/Dec', 9, 36], ['Hiệu chỉnh', '15–18/Dec · HR + BOD', 0, 7], ['Công bố', '20/Dec', 0, 1]] },
  { id: 'PB-LAN', name: 'Thử việc · Võ Thị Lan', type: 'Thử việc', range: '03/Nov/2026 – 02/Jan/2027', status: 'open', steps: [['Tự đánh giá', 'trước 26/Dec', 0, 1], ['Quản lý chấm', 'trước 29/Dec', 0, 1], ['Kết luận', 'HĐ chính thức / dừng', 0, 1]] },
  { id: 'PB-BAO', name: 'Thử việc · Trần Quốc Bảo', type: 'Thử việc', range: '19/Oct – 19/Dec/2026', status: 'open', steps: [['Tự đánh giá', 'trước 12/Dec', 0, 1], ['Quản lý chấm', 'trước 15/Dec', 0, 1], ['Kết luận', 'HĐ chính thức / dừng', 0, 1]] },
  { id: 'H26', name: 'Giữa năm 2026', type: 'Định kỳ 6 tháng', range: '01/Jun – 20/Jun/2026', status: 'closed', steps: [['Tự đánh giá', '01–07/Jun', 35, 35], ['Quản lý chấm', '08–14/Jun', 35, 35], ['Hiệu chỉnh', '15–18/Jun', 7, 7], ['Công bố', '20/Jun', 1, 1]] },
];

export const CYCLE_TYPES = ['Định kỳ 6 tháng', 'Định kỳ năm', 'Thử việc', 'Đột xuất'] as const;

export function cycleStepView(steps: readonly CycleStep[]) {
  return steps.map(([k, when, d, n], i) => {
    const p = n ? d / n : 0;
    const prev = steps[i - 1];
    const cur = p < 1 && (i === 0 || (prev ? prev[2] >= prev[3] * 0.5 : false));
    return { n: i + 1, k, when, prog: `${d}/${n}`, pct: Math.round(p * 100), state: p >= 1 ? 'done' : cur ? 'cur' : 'todo', hasLine: i < steps.length - 1 } as const;
  });
}

/** 0 chưa làm · 1 nháp · 2 đã nộp */
export type Prog = 0 | 1 | 2;
export interface Person { user: string; name: string; seat: string; mgr: string; self: Prog; mgrDone: Prog; kpi: number }
export const PROG_LABEL = ['Chưa làm', 'Nháp', 'Đã nộp'] as const;

const P = (user: string, name: string, seat: string, mgr: string, self: Prog, mg: Prog, kpi: number): Person => ({ user, name, seat, mgr, self, mgrDone: mg, kpi });
const PEOPLE: readonly Person[] = [
  P('PhuongHT', 'Hà Thanh Phương', 'CSD-BKG · L03', 'NGOCANH', 2, 2, 91), P('NhiTHT', 'Trần Hoàng Thảo Nhi', 'CSD-BKG · L03', 'NGOCANH', 2, 1, 84),
  P('TUANNT', 'Nguyễn Thanh Tuấn', 'OPS-DOC · L04', 'PHONGNT', 2, 0, 88), P('MAITTN', 'Trần Thị Ngọc Mai', 'SALE-SE · L03', 'DAVID', 2, 0, 79),
  P('NhungTT', 'Thân Thị Nhung', 'ACC-TAX · L04', 'PHILIP', 1, 0, 93), P('AnNV', 'Nguyễn Văn An', 'OPS-FLD · L03', 'PHONGNT', 0, 0, 76),
  P('ThangNV', 'Nguyễn Văn Thắng', 'OPS-FLD · L02', 'PHONGNT', 0, 0, 72), P('HOATTN', 'Trần Thị Như Hoa', 'WH-OPS · L02', 'KHAINH', 2, 2, 86),
];
const PROBATION: Record<string, readonly Person[]> = {
  'PB-LAN': [P('LanVT', 'Võ Thị Lan', 'CSD-CSO · L02 · thử việc', 'NGOCANH', 0, 0, 0)],
  'PB-BAO': [P('BaoTQ', 'Trần Quốc Bảo', 'SALE-SE · L02 · thử việc', 'DAVID', 1, 0, 0)],
};

/** Người trong kỳ; `saved` = các khoá `kỳ:user` đã gửi kết quả (giả lập trong bộ nhớ). */
export function cyclePeople(c: Cycle, saved: Readonly<Record<string, boolean>> = {}): Person[] {
  const base = PROBATION[c.id] ?? (c.status === 'closed' ? PEOPLE.map((p) => ({ ...p, self: 2 as Prog, mgrDone: 2 as Prog })) : PEOPLE);
  return base.map((p) => (saved[`${c.id}:${p.user}`] ? { ...p, self: 2 as Prog, mgrDone: 2 as Prog } : p));
}

export type PeopleFilter = 'all' | 'self' | 'mgr' | 'done';
export const PEOPLE_FILTERS: readonly PeopleFilter[] = ['all', 'self', 'mgr', 'done'];
export function matchFilter(p: Person, f: PeopleFilter): boolean {
  return f === 'all' || (f === 'self' && p.self < 2) || (f === 'mgr' && p.self === 2 && p.mgrDone < 2) || (f === 'done' && p.mgrDone === 2);
}
export const countNotDone = (ps: readonly Person[]): number => ps.filter((p) => p.self < 2 || p.mgrDone < 2).length;

// ---- Phiếu đánh giá ----
export const COMPS: readonly (readonly [string, string])[] = [['Nghiệp vụ chứng từ', 'BL, SI, VGM đúng cut-off'], ['Giao tiếp khách hàng', 'Phản hồi mail ≤ 2 giờ làm việc'], ['Tuân thủ SOP', 'Theo SOP của phòng'], ['Dùng hệ thống HANA', 'Ezy · Box · Mee'], ['Làm việc nhóm', 'Bàn giao khi nghỉ · hỗ trợ ca']];
export const SELF_SCORES = [4, 3, 4, 5, 4];
export type Grade = 'A' | 'B' | 'C' | 'D' | '—';

/** Điểm quản lý chấm: mặc định theo tự đánh giá khi đã nộp đủ 2 bước (như board); chưa chấm = 0. */
export function mgrScores(p: Person, override: Readonly<Record<number, number>>): number[] {
  return COMPS.map((_, i) => override[i] ?? (p.mgrDone === 2 ? (SELF_SCORES[i] ?? 0) - (i % 2) : 0));
}
/** Tổng = 40% năng lực (quản lý chấm) + 60% KPI kỳ. */
export function reviewTotal(scores: readonly number[], kpi: number): { done: boolean; total: number; grade: Grade } {
  const done = scores.length > 0 && scores.every((v) => v > 0);
  if (!done) return { done, total: 0, grade: '—' };
  const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
  const total = Math.round((avg / 5) * 100 * 0.4 + kpi * 0.6);
  return { done, total, grade: total >= 90 ? 'A' : total >= 75 ? 'B' : total >= 60 ? 'C' : 'D' };
}

// ---- OKR ----
/** [id, nhãn KR, chủ, giá trị, mục tiêu, đơn vị, nghịch (càng thấp càng tốt)] */
export type KrDef = readonly [string, string, string, number, number, string, boolean?];
export interface Objective { id: string; level: string; name: string; owner: string; krs: readonly KrDef[] }
export const OBJECTIVES: readonly Objective[] = [
  { id: 'O1', level: 'Công ty', name: 'Giữ chân khách hàng lớn', owner: '[BOD-DIR] PHILIP', krs: [['K11', 'Booking Confirmed đúng hạn ≥ 90%', 'NGOCANH', 88, 90, '%'], ['K12', 'Khiếu nại chứng từ ≤ 3 / tháng', 'PHONGNT', 4, 3, ' vụ', true], ['K13', '20 khách top được thăm định kỳ', 'DAVID', 14, 20, '']] },
  { id: 'O2', level: 'Phòng HR', name: 'Số hoá quy trình nhân sự', owner: '[HRD-MGR] HANHLTM', krs: [['K21', '100% đơn từ qua HANA Mee', 'HANHLTM', 92, 100, '%'], ['K22', 'Bảng công tự động ở 3 chi nhánh', 'HANHLTM', 2, 3, ''], ['K23', '36/36 nhân sự đăng ký khuôn mặt', 'HANHLTM', 34, 36, '']] },
  { id: 'O3', level: 'Phòng OPS', name: 'Không trễ cut-off SI', owner: '[OPS-MGR] PHONGNT', krs: [['K31', 'SI đúng cut-off ≥ 98%', 'TUANNT', 97, 98, '%'], ['K32', 'Draft B/L gửi khách ≤ 1 ngày làm việc', 'TUANNT', 94, 95, '%']] },
];
export type Conf = 'ok' | 'warn' | 'err';
export function krProgress(v: number, goal: number, inverse?: boolean): { p: number; conf: Conf; pct: number } {
  const p = inverse ? Math.min(1, goal / Math.max(v, 0.0001)) : Math.min(1, v / goal);
  return { p, pct: Math.round(p * 100), conf: p >= 0.95 ? 'ok' : p >= 0.8 ? 'warn' : 'err' };
}
export function objectiveAvg(o: Objective, ov: Readonly<Record<string, number>>): number {
  if (!o.krs.length) return 0;
  return Math.round(o.krs.reduce((a, k) => a + krProgress(ov[k[0]] ?? k[3], k[4], k[6]).pct, 0) / o.krs.length);
}
export const matchLevel = (o: Objective, lv: string): boolean => lv === 'all' || o.level.startsWith(lv);

// ---- Khung năng lực ----
export const POSITIONS = ['CSD-BKG', 'OPS-DOC', 'SALE-SE', 'WH-OPS'] as const;
export const LEVELS = ['L01', 'L02', 'L03', 'L04', 'L05'] as const;
export const FRAME: readonly (readonly [string, readonly number[]])[] = [['Nghiệp vụ chứng từ', [2, 3, 3, 4, 5]], ['Giao tiếp khách hàng', [2, 2, 3, 4, 4]], ['Tiếng Anh thương mại', [2, 2, 3, 3, 4]], ['Tuân thủ SOP', [3, 3, 4, 4, 5]], ['Dùng hệ thống HANA', [2, 3, 3, 4, 4]], ['Dẫn dắt nhóm', [1, 1, 2, 3, 4]]];
export const GAPS: readonly (readonly [string, number, string])[] = [['Tiếng Anh thương mại', 4, 'Email tiếng Anh cho Booking'], ['Dùng hệ thống HANA', 2, 'HANA Ezy cơ bản'], ['Dẫn dắt nhóm', 1, 'Kèm cặp người mới']];
/** Bấm ô để đổi mức: 1→5 rồi quay về 1. */
export const nextLevel = (v: number): number => (v >= 5 ? 1 : v + 1);
